/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DefaultBackground {
    GARDEN = 'GARDEN',
    POOL = 'POOL',
    CABIN = 'CABIN',
    NONE = 'NONE',
}